/*
 * Pick (for jQuery)
 *  Ex:
 *  var how_many = jQuery('#gallery li').pick(6).size(); // Will return 6.
 */

(function($){
$(document).ready(function(){
  $.fn.pick = function(how_many) {
    
    var how_many = how_many || 4; 
  
    // Picking random numbers without repeating. 
    var index_array = [];
   var original_obj_size = this.length;
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,how_many);
    
    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
       if ($.inArray(i,new_index_array) === -1) {
          $(this).remove();
       }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
  // $('.homebloglist > div.singlerandom').pick(1).each(function(i) {
  //     if ((i+1)%3 === 0) {
  //       jQuery(this).addClass('last');
  //     }
  //     else {
  //       jQuery(this).removeClass('last');
  //     }
  //   });
 
    $('.productrendome_beanies > div').pick(4).each(function(i) {
      if ((i+1)%3 === 0) {
        jQuery(this).addClass('last');
      }
      else {
        jQuery(this).removeClass('last');
      }
    });

   $('.productrendome_loungewear > div').pick(4).each(function(i) {
      if ((i+1)%3 === 0) {
        jQuery(this).addClass('last');
      }
      else {
        jQuery(this).removeClass('last');
      }
    });
   $('.productrendome_techwear > div').pick(4).each(function(i) {
      if ((i+1)%3 === 0) {
        jQuery(this).addClass('last');
      }
      else {
        jQuery(this).removeClass('last');
      }
    });
  });
})(jQuery);